import { graphql } from "@/lib/gql/__generated__";

export const PlanStaticRoomPriceParams_PlanManagementPage_Query = graphql(`
	query PlanStaticRoomPriceParams_PlanManagementPage($hotelID: ID!, $roomIDs: [ID!]!) {
		planStaticRoomPriceParams(hotelID: $hotelID, roomIDs: $roomIDs) {
			id
			staticRoomPriceParams {
				staticRoomPrices {
					roomID
					roomName
					prices {
						adultNum
						price {
							currencyType
							amount
						}
					}
				}
			}
		}
	}
`);
